import { DEV } from "solid-js"
import { quaternionFromYRotation } from "../../../three/fn/quaternionFromYRotation"
import { HALF_PI, PI } from "../../util/math/Math"
import { freeze } from "../../util/Object"

export const CLOCKWISE = 0
export const COUNTER_CLOCKWISE = 1

export type CLOCKWISE_OR_COUNTER_CLOCKWISE = typeof CLOCKWISE | typeof COUNTER_CLOCKWISE

export const EntityHeadingDeg = {
  North: 0,
  East: 90,
  South: 180,
  West: 270,
} as const

export const EntityHeadingRad = {
  North: 0,
  East: HALF_PI,
  South: PI,
  West: PI * 1.5,
} as const

export const EntityHeadingQuaternion = {
  North: quaternionFromYRotation(EntityHeadingRad.North),
  East: quaternionFromYRotation(EntityHeadingRad.East),
  South: quaternionFromYRotation(EntityHeadingRad.South),
  West: quaternionFromYRotation(EntityHeadingRad.West),
} as const

if (DEV) {
  freeze(EntityHeadingQuaternion.North)
  freeze(EntityHeadingQuaternion.East)
  freeze(EntityHeadingQuaternion.South)
  freeze(EntityHeadingQuaternion.West)
}

// export const SQRT2_OVER_2 = SQRT2 / 2
// export const EntityHeadingWestQuaternion : Quaternion = new Quaternion(0, 0, SQRT2_OVER_2, SQRT2_OVER_2)
// export const EntityHeadingNorthQuaternion : Quaternion = new Quaternion(0, 0, 0, 1)
// export const EntityHeadingEastQuaternion : Quaternion = new Quaternion(0, 0, SQRT2_OVER_2, -SQRT2_OVER_2)
// export const EntityHeadingSouthQuaternion : Quaternion = new Quaternion(0, 0, 1, 0)
